import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";
import { isAdminAuthed } from "../lib/api";

export const Header = () => {
  const { pathname } = useLocation();
  const showAdminLink = isAdminAuthed();
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-slate-200"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 lg:px-10 h-16">
        <Link
          to="/"
          data-testid="nav-home-link"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-slate-900 text-white">
            <Compass size={18} strokeWidth={2.25} />
          </span>
          <span className="font-display font-bold text-[17px] tracking-tight text-slate-900">
            Mattoo<span className="text-amber-600">.</span>
            <span className="text-slate-500 font-medium ml-1">
              RoleFinder
            </span>
          </span>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          <Link
            to="/"
            data-testid="nav-start-link"
            className={`hidden sm:inline text-slate-600 hover:text-slate-900 ${pathname === "/" ? "text-slate-900" : ""}`}
          >
            Start
          </Link>
          {showAdminLink && (
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className={`hidden sm:inline text-slate-600 hover:text-slate-900 ${pathname === "/admin" ? "text-slate-900 font-semibold" : ""}`}
            >
              Admin
            </Link>
          )}
          <a
            href="https://www.mattooconsulting.com"
            target="_blank"
            rel="noreferrer"
            data-testid="nav-coaching-link"
            className="inline-flex items-center gap-1 px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition-colors"
          >
            Get 1:1 Coaching
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
